module.exports = __webpack_public_path__ + "media/hihat.4ba39e07.wav";